import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuthState } from './auth-state-context';

// Reactive replacement for "navigate on sign-out" living inside the sign-out
// button handler (and for the previous SessionExpiredDialog gate on
// `!sessionExpired`). Signing out, an idle-timeout expiration, and a failed
// token refresh (`onSessionExpired`) all clear the auth store the same way —
// none of them navigated, so the user was left staring at a dead screen
// until a reload/tab switch re-ran the route guards. Watching
// `session === null` here means every path that clears the session is
// covered by a single reactive check, instead of requiring each caller (or
// a modal the user has to click through) to also handle navigation.
export function useRedirectWhenSignedOut(): void {
  const { session } = useAuthState();
  const navigate = useNavigate();

  useEffect(() => {
    if (session === null) {
      void navigate({ to: '/login' });
    }
  }, [session, navigate]);
}
